import { render, staticRenderFns } from "./GrmTasa.vue?vue&type=template&id=ba95e0cc&"
import script from "./GrmTasa.vue?vue&type=script&lang=js&"
export * from "./GrmTasa.vue?vue&type=script&lang=js&"
import style0 from "./GrmTasa.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports